import type { FormValues } from './';

export default (values: FormValues) => {
  const validationErrors = {};
  if (!values.name) {
    validationErrors.name = 'Occorre inserire un nome per la Produzione';
  }
  // if (!values.edition) {
  //   validationErrors.edition = 'Occorre inserire una Edizione';
  // }
  if (isNaN(parseInt(String(values.areaId), 10))) {
    validationErrors.areaId = 'Occorre selezionare una Area';
  }
  if (isNaN(parseInt(String(values.productionTypeId), 10))) {
    validationErrors.productionTypeId = 'Occorre selezionare un tipo di Produzione';
  }
  // if (isNaN(parseInt(String(values.quantity), 10))) {
  //   validationErrors.quantity = 'Occorre inserire una quantità valida';
  // }
  return validationErrors;
};
